import { ArrowBackRounded } from "@mui/icons-material";
import classNames from "classnames";
import { ReactNode } from "react";
import IconButton from "../ui/IconButton";
import styles from "./css/Page.module.css";

interface PageProps {
  children: ReactNode;
  // narrow: 640px (학습 · 설정), medium: 880px (단어 목록), wide: 1280px
  width?: "narrow" | "medium" | "wide";
  className?: string;
}

// 화면 본문 영역. 화면 폭에 맞춘 좌우 여백과 최대 너비를 일정하게 맞춘다.
export function Page({ children, width = "narrow", className }: PageProps) {
  return (
    <div className={classNames(styles.page, styles[width], className)}>
      {children}
    </div>
  );
}

interface PageHeaderProps {
  title: ReactNode;
  // 있으면 왼쪽에 뒤로가기 버튼을 보여준다
  onBack?: () => void;
  backLabel?: string;
  actions?: ReactNode;
  subtitle?: ReactNode;
}

export function PageHeader({
  title,
  onBack,
  backLabel = "뒤로",
  actions,
  subtitle,
}: PageHeaderProps) {
  return (
    <header className={styles.header}>
      <div className={styles.headerRow}>
        {onBack && (
          <IconButton
            aria-label={backLabel}
            icon={<ArrowBackRounded />}
            className={styles.back}
            onClick={onBack}
          />
        )}
        <h1 className={styles.title}>{title}</h1>
        {actions && <div className={styles.actions}>{actions}</div>}
      </div>
      {subtitle && <div className={styles.subtitle}>{subtitle}</div>}
    </header>
  );
}
